<template>
  <div class="top-navbar">
    <div class="row w-100 g-2 align-items-center">
      <div class="col">
        <div class="row g-2">
          <div class="col-12 col-md-auto">
            <label class="fw-bold">Title:</label><input type="text" v-model="title">
          </div>
          <div class="col-12 col-md-auto">
            <label class="fw-bold">Date:</label><input type="text" v-model="date">
          </div>
        </div>
      </div>
      <div class="col-auto">
        <RouterLink v-if="showHome" to="/" class="home-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="black">
            <path d="M10 20v-6h4v6h6v-8h3L12 3 2 12h3v8z"/>
          </svg>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopNav",
  props: {
    pageTitle: {
      type: String,
      default: ""
    },
    showHome: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      title: this.pageTitle,
      date: this.getTodayDate()
    };
  },
  methods: {
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Serif+Pro:wght@400;600;700&display=swap');

.top-navbar {
  min-height: 20px;
  background-color: transparent;
  padding: 0;
}

.home-link {
  color: black;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: opacity 0.2s ease;
}

.home-link:hover {
  opacity: 0.7;
}
</style>